export const spanishMessages = {
  ra: {
    action: {
      add_filter: "Agregar filtro",
      back: "Volver",
      cancel: "Cancelar",
      clear_input_value: "Limpiar valor",
      clone: "Duplicar",
      confirm: "Confirmar",
      create: "Crear",
      delete: "Eliminar",
      edit: "Editar",
      export: "Exportar",
      list: "Lista",
      refresh: "Actualizar",
      remove: "Quitar",
      save: "Guardar",
      search: "Buscar",
      show: "Mostrar",
      sort: "Ordenar",
      undo: "Deshacer",
    },
    auth: {
      auth_check_error: "Inicia sesion para continuar",
      email: "Correo",
      logout: "Cerrar sesion",
      password: "Contrasena",
      sign_in: "Ingresar",
      sign_in_error: "No fue posible iniciar sesion",
      user_menu: "Perfil",
    },
    boolean: { false: "No", null: "Sin definir", true: "Si" },
    configurable: { configureMode: "Configurar pagina" },
    input: {
      file: {
        upload_several: "Arrastra archivos o haz clic para seleccionarlos.",
        upload_single: "Arrastra un archivo o haz clic para seleccionarlo.",
      },
      image: {
        upload_several: "Arrastra imagenes o haz clic para seleccionarlas.",
        upload_single: "Arrastra una imagen o haz clic para seleccionarla.",
      },
      references: {
        all_missing: "No se encontraron las referencias.",
        many_missing: "Algunas referencias ya no estan disponibles.",
        single_missing: "La referencia ya no esta disponible.",
      },
    },
    message: {
      are_you_sure: "Estas seguro?",
      bulk_delete_content: "Se eliminaran los elementos seleccionados.",
      bulk_delete_title: "Eliminar elementos",
      delete_content: "Esta accion no se puede deshacer.",
      delete_title: "Eliminar %{name}",
      error: "Ocurrio un error y la solicitud no se completo.",
      invalid_form: "Revisa los errores del formulario.",
      loading: "Cargando...",
      no: "No",
      not_found: "La pagina no existe.",
      yes: "Si",
    },
    navigation: {
      next: "Siguiente",
      no_more_results: "No hay mas resultados.",
      no_results: "Sin resultados",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de mas de %{offsetEnd}",
      prev: "Anterior",
      skip_nav: "Ir al contenido",
    },
    notification: {
      bad_item: "Elemento incorrecto",
      canceled: "Accion cancelada",
      created: "Elemento creado",
      deleted: "Elemento eliminado |||| %{smart_count} elementos eliminados",
      http_error: "Error de comunicacion con el servidor",
      item_doesnt_exist: "El elemento ya no existe",
      updated:
        "Elemento actualizado |||| %{smart_count} elementos actualizados",
    },
    page: {
      create: "Crear %{name}",
      dashboard: "Dashboard",
      edit: "Editar %{name}",
      empty: "Aun no hay %{name}.",
      error: "Ocurrio un error",
      invite: "Quieres crear uno?",
      list: "%{name}",
      loading: "Cargando",
      not_found: "No encontrado",
      show: "%{name}",
    },
    validation: {
      email: "Debe ser un correo valido",
      maxLength: "Debe tener %{max} caracteres o menos",
      maxValue: "Debe ser %{max} o menos",
      minLength: "Debe tener al menos %{min} caracteres",
      minValue: "Debe ser al menos %{min}",
      number: "Debe ser un numero",
      oneOf: "Debe ser uno de estos valores: %{options}",
      regex: "El formato no es valido",
      required: "Campo obligatorio",
    },
  },
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre",
        website: "Sitio web",
        domain: "Dominio",
        linkedin_url: "LinkedIn",
        phone_number: "Telefono",
        created_at: "Creada",
        sector: "Industria",
        size: "Tamano",
        address: "Direccion",
        city: "Ciudad",
        country: "Pais",
        description: "Descripcion",
        sales_id: "Responsable",
        status: "Estado",
        source: "Fuente",
        next_follow_up: "Proximo seguimiento",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
      },
      empty: {
        description: "No hay empresas registradas.",
        title: "Sin empresas",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        title: "Cargo",
        department: "Departamento",
        decision_role: "Rol de decision",
        company_id: "Empresa",
        email_jsonb: "Correos",
        phone_jsonb: "Telefonos",
        linkedin_url: "LinkedIn",
        sales_id: "Responsable",
        next_follow_up: "Proximo seguimiento",
      },
      action: {
        add: "Agregar contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        new: "Nuevo contacto",
      },
      empty: {
        description: "No hay contactos registrados.",
        title: "Sin contactos",
      },
      import: {
        title: "Importar contactos",
        button: "Importar CSV",
        csv_file: "Archivo CSV",
      },
    },
    deals: {
      name: "Oportunidad |||| Oportunidades",
      fields: {
        name: "Nombre",
        description: "Descripcion",
        company_id: "Empresa",
        primary_contact_id: "Contacto principal",
        contact_ids: "Contactos",
        amount: "Valor",
        currency: "Moneda",
        probability: "Probabilidad",
        expected_closing_date: "Cierre estimado",
        stage: "Etapa",
        next_step: "Proximo paso",
        loss_reason: "Motivo de perdida",
      },
      action: { create: "Crear oportunidad", new: "Nueva oportunidad" },
      updated: "Oportunidad actualizada",
    },
    notes: { name: "Nota |||| Notas" },
    sales: {
      name: "Integrante |||| Integrantes",
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo",
        administrator: "Admin",
        disabled: "Desactivado",
        pending: "Pendiente",
      },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      fields: {
        text: "Descripcion",
        due_date: "Fecha limite",
        type: "Tipo",
        contact_id: "Contacto",
        priority: "Prioridad",
        status: "Estado",
      },
      action: {
        add: "Agregar tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      empty: "Sin tareas",
      filters: {
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Manana",
      },
    },
    tags: { name: "Etiqueta |||| Etiquetas" },
  },
  crm: {
    auth: {
      sign_in_google: "Continuar con Google",
      sign_in_google_workspace: "Continuar con Google Workspace",
      welcome_title: "BaskervilleAI CRM",
      recovery_email_sent:
        "Si la cuenta existe, recibiras un correo de recuperacion.",
    },
    common: {
      activity: "Actividad",
      details: "Detalles",
      load_more: "Cargar mas",
      loading: "Cargando...",
      me: "Yo",
      retry: "Reintentar",
    },
    dashboard: {
      deals_chart: "Ingresos estimados",
      deals_pipeline: "Pipeline",
      latest_activity: "Actividad reciente",
      latest_notes: "Notas recientes",
      upcoming_tasks: "Tareas proximas",
    },
    header: { import_data: "Importar datos" },
    language: "Idioma",
    navigation: { label: "Navegacion del CRM" },
    profile: { title: "Perfil", updated: "Perfil actualizado" },
    settings: {
      title: "Configuracion",
      preferences: "Preferencias",
      app_title: "Nombre de la aplicacion",
      saved: "Configuracion guardada",
      saving: "Guardando...",
    },
    theme: { dark: "Oscuro", label: "Tema", light: "Claro", system: "Sistema" },
  },
  "ra-supabase": {
    auth: {
      forgot_password: "Olvidaste tu contrasena?",
      password_reset: "Revisa tu correo para restablecer la contrasena.",
    },
  },
} as const;
